var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{staticClass:"logo-position",staticStyle:{"transition":"all 0.5s ease"},style:({'transform' : _vm.hide ? 'translateY(-30vh)' : 'translateY(0px)'}),attrs:{"max-width":_vm.compact ? 120 : 400,"src":_vm.getLogoFile(_vm.logoImage)}})
}
var staticRenderFns = []

export { render, staticRenderFns }